import angular from 'angular';
import teamRequestCoincidencesMobileComponent from './teamRequestCoincidencesMobile.component';

let teamRequestCoincidencesMobileModule = angular.module('teamRequestCoincidencesMobile', [])

  .component('teamRequestCoincidencesMobile', teamRequestCoincidencesMobileComponent)

  .name;

export default teamRequestCoincidencesMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCoincidencesMobile/teamRequestCoincidencesMobile.js